import {createSelector} from 'reselect';
import {combineReducers} from 'redux';

// ! should split out and have multiple imports for usage
// ! e.g. - @stencil/user-reducer/selectors or /actions likewise

export interface IUserStoreState {
  userInfo: IUserInfo;
  gocashInfo: IGocashInfo;
}

export interface IUserInfo {
  first_name?: string;
  last_name?: string;
  email?: string;
  profileId: string;
  profile_type?: string;
  image_url?: string;
  gender?: string;
  uuid?: string;
}
export interface IGocashInfo {
  is_locked?: number;
  t_amt?: number;
}

export const UPDATE_GO_CASH_INFO  = 'UPDATE_GO_CASH_INFO';
export const UPDATE_USER_INFO     = 'UPDATE_USER_INFO';

const initialState: IUserStoreState = {
  userInfo: {
    email: "",
    first_name: "",
    gender: "",
    image_url: "",
    last_name: "",
    profile_type: "",
    profileId: "",
    uuid: ""
  },
  gocashInfo: null
};

export function userDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_GO_CASH_INFO:
      return {
        ...state,
        gocashInfo: action.gocashInfo
      };

    case UPDATE_USER_INFO: 
      return {
        ...state,
        userInfo: action.userInfo
      }

    default:
      return state;
  }
}

export const userReducer = {
  user: userDetailsReducer
};

export const userSelector = createSelector(
  (state: UserAppState) => state.user,
  item => item,
);

const rootReducer = combineReducers(userReducer);

export type UserAppState = ReturnType<typeof rootReducer>;
